import { AddConsultationDatesRequestData } from '../../../../../types/models/consultations/consultation.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../../../utils/api/endpoints/consultationsEndpoints';

const PREFIX = '[addDatesQuery]';

export const ADD_CONSULTATIONS_DATES_QUERY_KEY = 'ADD_CONSULTATIONS_DATES';

export const queryAddDates = async (
  consultationId: number,
  dates: AddConsultationDatesRequestData
) => {
  console.log(PREFIX, `Creating consultations dates...`);
  const response = await CONSULTATIONS_ENDPOINTS.addDates(consultationId, dates);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Created consultations dates.`);
  return json;
};
